import type { Locale } from "./i18n";

const labels: Record<Locale, string> = {
  en: "Download",
  "zh-tw": "下載",
  "zh-cn": "下载",
  ja: "ダウンロード",
  ko: "다운로드",
  es: "Descargar",
  "pt-br": "Baixar",
  fr: "Télécharger",
  de: "Herunterladen",
  id: "Unduh",
  vi: "Tải xuống",
  th: "ดาวน์โหลด"
};

export function getDownloadOptionsLabel(locale: Locale): string {
  return labels[locale];
}
